require('./message-popup.html');
require('./message-popup.controller');